// SPDX-License-Identifier: AGPL-3.0-or-later

import type {RestRequestOptions} from '@app/features/platform/types/TransportTypes';

/**
 * KONVO: for reads whose failure puts an error in front of the person (a card that "could not be
 * loaded", an empty list with a retry button). The default 'strict' mode fails a 429 at once;
 * this waits out its Retry-After, and retries a dropped connection with backoff, a few times.
 */
export const RETRY_RATE_LIMITS = {mode: 'auto-retry', retries: 3} as const satisfies Pick<
	RestRequestOptions,
	'mode' | 'retries'
>;
